import React, {useEffect} from 'react'
import {FieldComponent} from 'components/Shared/FieldComponent'
import styles from 'components/Contractors/InsurancePolicy/Form/InsurancePolicyForm.module.css'
import {CurrencySelectField} from "../../../Shared/CurrencySelectField";
import {useFormikContext} from "formik";

export function PriceFields({
                              amountFieldName,
                              amountLabel,
                              currencyCodeFieldName,
                              currencyCodeLabel,
                              disabled,
                              currencyLocked,
                              autoValue,
                            }) {
  const {setFieldValue} = useFormikContext()

  useEffect(() => {
    setFieldValue(amountFieldName, autoValue)
  }, [autoValue, setFieldValue, amountFieldName]);

  return <div className={styles.priceField}>
    <FieldComponent fieldName={amountFieldName}
                    label={amountLabel}
                    className={styles.valueField}
                    type="number"
                    disabled={disabled}
    />
    <CurrencySelectField fieldName={currencyCodeFieldName}
                         label={currencyCodeLabel}
                         className={styles.currencyField}
                         disabled={currencyLocked || disabled}
    />
  </div>
}